module.exports = __webpack_public_path__ + "static/media/ApakahPembahagianTerbaikBagiGajiBulananAndaolehBankNegaraMalaysia.c1fe8d32.jpg";